export interface Project {
  project_id: number;
  batch_project_id: number;
  batch_project_name: string;
}

interface FiltersData {
  courses: string[];
  batches: {
    [course: string]: string[];
  };
  subjects: {
    [course: string]: {
      [batch: string]: string[];
    };
  };
  projects?: {
    [course: string]: {
      [batch: string]: Project[];
    };
  };
}

interface CourseDropdownProps {
  filtersData: FiltersData | null;
  selectedCourse: string;
  selectedBatch: string;
  selectedSubject: string;
  selectedProject: Project | null;
  onCourseChange: (course: string) => void;
  onBatchChange: (batch: string) => void;
  onSubjectChange: (subject: string) => void;
  onProjectChange: (project: Project | null) => void;
}

const CourseDropdown: React.FC<CourseDropdownProps> = ({
  filtersData,
  selectedCourse,
  selectedBatch,
  selectedSubject,
  selectedProject,
  onCourseChange,
  onBatchChange,
  onSubjectChange,
  onProjectChange,
}) => {
  return (
    <div className="filters-section">
      <div className="filter-group">
        <label>Course</label>
        <select
          className="filter-dropdown"
          value={selectedCourse}
          onChange={(e) => onCourseChange(e.target.value)}
        >
          {filtersData?.courses.map((course) => (
            <option key={course} value={course}>
              {course}
            </option>
          ))}
        </select>
      </div>
      <div className="filter-group">
        <label>Batch</label>
        <select
          className="filter-dropdown"
          value={selectedBatch}
          onChange={(e) => onBatchChange(e.target.value)}
        >
          {filtersData?.batches[selectedCourse]?.map((batch) => (
            <option key={batch} value={batch}>
              {batch}
            </option>
          ))}
        </select>
      </div>
      <div className="filter-group">
        <label>Project</label>
        <select
          className="filter-dropdown"
          value={selectedProject ? `${selectedProject.project_id}_${selectedProject.batch_project_id}` : ""}
          onChange={(e) => {
            const value = e.target.value;
            if (!value || !filtersData?.projects?.[selectedCourse]?.[selectedBatch]) {
              onProjectChange(null);
            } else {
              const project = filtersData.projects[selectedCourse][selectedBatch].find(
                (p) => `${p.project_id}_${p.batch_project_id}` === value
              );
              onProjectChange(project ?? null);
            }
          }}
          disabled={!selectedBatch}
        >
          <option value="">Select Project</option>
          {filtersData?.projects?.[selectedCourse]?.[selectedBatch]?.map((project) => (
            <option key={`${project.project_id}_${project.batch_project_id}`} value={`${project.project_id}_${project.batch_project_id}`}>
              {project.batch_project_name}
            </option>
          ))}
        </select>
      </div>

      <div className="d-flex align-items-center">
        <div className="flex-grow-1 border-top"></div>
        <span className="px-3 text-muted text-uppercase small fw-medium">OR</span>
        <div className="flex-grow-1 border-top"></div>
      </div>

      <div className="filter-group">
        <label>Subject</label>
        <select
          className="filter-dropdown"
          value={selectedSubject}
          onChange={(e) => onSubjectChange(e.target.value)}
          disabled={!selectedBatch}
        >
          <option value="">Select Subject</option>
          {filtersData?.subjects[selectedCourse]?.[selectedBatch]?.map((subject) => (
            <option key={subject} value={subject}>
              {subject}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default CourseDropdown;
